export default __webpack_public_path__ + "img/BB_RT_250MA_BF.b6a79d16777fbaf0032bde0f47956f05.jpg";